export default "__VITE_ASSET__W4vI37Bj__"